import {
    AccordionList,
    Headline2,
    Paragraph
} from '@cdm/quickenloans-library/lib';
import PropTypes from 'prop-types';
import React from 'react';
import { accordionGroupContainer, accordionListContainer, accordionListHeadlines } from './AccordionGroup.module.scss';
import { testAttributes } from './Constants';

const AccordionGroup = ({
    as = "prefixPostfixList",
    className,
    defaultExpanded = false,
    description,
    items,
    title,
    variation="secondary"
}) => (
    <div className={`${accordionGroupContainer} ${className || ''}`} data-testid={testAttributes.ACCORDION_GROUP_CONTAINER}>
        <div className={accordionListHeadlines} data-testid={testAttributes.ACCORDION_GROUP_HEADLINES}>
            <Headline2 className="h2_semi_bold_newSize">{title}</Headline2>
            {description && <Paragraph className="para_regular" style={{margin: 0}}>{description}</Paragraph>}
        </div>
        <div className={accordionListContainer} data-testid={testAttributes.ACCORDION_GROUP_LIST_CONTAINER}>
            {items && items.map(({ question, answer }) => <AccordionList
                as={as}
                title={question}
                defaultExpanded={defaultExpanded}
                variation={variation}
            >
                <Paragraph className="para_regular" style={{margin: 0}} itemType="https://schema.org/Answer">
                    {answer}
                </Paragraph>
            </AccordionList>
            )}
        </div>
    </div>
);

AccordionGroup.propTypes = {
    as: PropTypes.oneOf([
        "prefixList",
        "postfixList",
        "prefixPostfixList"
    ]),
    className: PropTypes.string,
    description: PropTypes.string,
    defaultExpanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            question: PropTypes.arrayOf([
                PropTypes.string,
                PropTypes.element
            ]).isRequired,
            answer: PropTypes.arrayOf([
                PropTypes.string,
                PropTypes.element
            ]).isRequired
        })
    ).isRequired,
    variation: PropTypes.oneOf([
        "primary",
        "secondary",
    ])
};

export default AccordionGroup;